/* Carrito opcional. Releasit es el único editor de cantidades y total al recibir. */
(function () {
  var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  /* Los dos caminos de la ficha mantienen el mismo pack seleccionado. */
  var packSelect = document.querySelector('[data-vc-balm-pdp]');
  function syncPackSelection() {
    if (!packSelect) return;
    var radios = Array.from(document.querySelectorAll('#rsi_form_wrapper input[name="quantity_offer"]'));
    var index = radios.findIndex(function (radio) { return radio.checked; });
    if (index >= 0 && packSelect.options[index] && packSelect.selectedIndex !== index) packSelect.selectedIndex = index;
  }
  if (packSelect) {
    document.addEventListener('change', function (event) {
      if (event.target === packSelect) {
        var radios = document.querySelectorAll('#rsi_form_wrapper input[name="quantity_offer"]');
        var radio = radios[packSelect.selectedIndex];
        if (radio && !radio.checked) radio.click();
      }
      if (event.target.matches('input[name="quantity_offer"]')) setTimeout(syncPackSelection, 150);
    });
    new MutationObserver(syncPackSelection).observe(document.body, { childList: true, subtree: true });
    syncPackSelection();
  }
  document.addEventListener('submit', async function (event) {
    var form = event.target.closest('[data-vc-add-cart]');
    if (!form) return;
    event.preventDefault();
    var button = form.querySelector('button'), error = form.querySelector('[role=alert]');
    if (button.disabled) return;
    button.disabled = true;
    button.textContent = 'Agregando…';
    error.hidden = true;
    try {
      var response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(form.elements.id.value), quantity: 1 }] }) });
      var data = await response.json();
      if (!response.ok) throw new Error(data.description || 'No pudimos agregar este cuidado. Intenta nuevamente.');
      window.location.assign(form.elements.return_to.value);
    } catch (exception) {
      error.textContent = exception.message;
      error.hidden = false;
      button.disabled = false;
      button.textContent = 'Agregar al carrito +';
    }
  });

  var page = document.querySelector('[data-vc-cart-page]');
  if (!page) return;
  var host = page.querySelector('[data-vc-cart-host]');
  if (!host) return;
  var loading = page.querySelector('[data-vc-cart-loading]'), status = page.querySelector('[data-vc-cart-status]'), warning = page.querySelector('[data-vc-cart-warning]');
  var lastTotal = '', busy = false, ready = false, retries = 0, blockedBalm = false;
  function setPending() {
    ready = false;
    host.removeAttribute('data-ready');
    status.hidden = false;
    status.textContent = 'Actualizando el total de tu carrito…';
  }
  function totalNumber(text) { return Number(String(text || '').replace(/[^0-9]/g, '')); }
  async function sync() {
    var form = document.getElementById('rsi_form_wrapper');
    if (busy) return;
    /* Conservar el contenedor que recibe los eventos del formulario React. */
    if (form) {
      var anchor = form.closest('#cart-wrapper') || document.getElementById('rsi-form-top-anchor') || form;
      if (!host.contains(anchor)) host.appendChild(anchor);
      loading.hidden = true;
    }
    var total = form && form.querySelector('.rsi-total-summary-total-value');
    busy = true;
    try {
      var response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error('No pudimos comprobar el total.');
      var cart = await response.json();
      if (!cart.item_count) { window.location.replace(page.dataset.cartUrl); return; }
      document.querySelectorAll('cart-icon [ref="cartBubbleCount"]').forEach(function (count) { count.textContent = String(Math.min(cart.item_count, 99)); });
      if (!form || !total) {
        if (lastTotal && retries++ < 15) setTimeout(sync, 400);
        return;
      }
      var balm = cart.items.find(function (item) { return item.handle === 'balsamo-facial-hidratante-antiarrugas'; });
      blockedBalm = Boolean(balm);
      if (balm) {
        warning.hidden = false;
        if (warning.dataset.line !== balm.key) {
        warning.replaceChildren();
        var p = document.createElement('p');
        p.textContent = 'El bálsamo que tenías guardado necesita una opción de pack. Elige cuál quieres para continuar con tu pedido.';
        var variants = [];
        try { variants = JSON.parse(page.querySelector('[data-vc-balm-variants]').textContent); } catch (e) {}
        if (variants.length) {
          var select = document.createElement('select'); select.className = 'vc-cart-pack-select'; select.setAttribute('aria-label', 'Reemplazar bálsamo guardado por un pack');
          variants.forEach(function (v) { var option = document.createElement('option'); option.value = v.id; option.textContent = v.title + ' · $' + new Intl.NumberFormat('es-CL').format(v.price / 100); select.appendChild(option); });
          var replaceButton = document.createElement('button'); replaceButton.type = 'button'; replaceButton.className = 'vc-button'; replaceButton.textContent = 'Usar este pack en mi carrito'; replaceButton.style.marginTop = '12px';
          replaceButton.addEventListener('click', async function () {
            replaceButton.disabled = true;
            try {
              var current = await (await fetch(root + 'cart.js', { cache: 'no-store' })).json();
              var updates = {}, existing = current.items.find(function (item) { return item.variant_id === Number(select.value); });
              updates[balm.key] = 0;
              updates[select.value] = (existing ? existing.quantity : 0) + 1;
              var result = await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) });
              if (!result.ok) throw new Error('No pudimos actualizar tu pack. Intenta nuevamente.');
              window.location.reload();
            } catch (e) { p.textContent = e.message; replaceButton.disabled = false; }
          });
          warning.append(p, select, replaceButton);
        } else warning.append(p);
        var link = document.createElement('a'); link.href = balm.url; link.textContent = 'Elegir mi pack de bálsamos ↗';
        warning.append(link);
        warning.dataset.line = balm.key;
        }
        host.setAttribute('data-ready', 'true');
        ready = false;
        status.hidden = false;
        status.textContent = 'Actualiza el bálsamo guardado al pack que prefieras para continuar.';
      } else {
        warning.hidden = true;
        ready = totalNumber(total.textContent) * 100 === cart.total_price;
        host.setAttribute('data-ready', 'true');
        status.hidden = ready;
        if (!ready) status.textContent = 'Actualizando el total de tu carrito…';
      }
      form.classList.toggle('vc-cart-total-pending', !ready);
      form.querySelectorAll('.rsi-submit_button,.rsi-additionals_checkout_button').forEach(function (button) { if (!ready) button.setAttribute('aria-disabled', 'true'); else button.removeAttribute('aria-disabled'); });
      lastTotal = total.textContent;
      if (!ready && !blockedBalm && retries++ < 15) setTimeout(sync, 400);
      else if (ready) retries = 0;
    } catch (exception) { setPending(); status.textContent = 'No pudimos comprobar el total. Actualiza la página antes de confirmar.'; }
    finally { busy = false; }
  }
  document.addEventListener('click', function (event) {
    if (event.target.closest('#rsi_form_wrapper .rsi-quantity-increase,#rsi_form_wrapper .rsi-quantity-decrease,#rsi_form_wrapper .rsi-product-item-remove')) {
      setPending(); setTimeout(sync, 300); setTimeout(sync, 1000); setTimeout(sync, 2000);
    }
    if (event.target.closest('#rsi_form_wrapper .rsi-submit_button,#rsi_form_wrapper .rsi-additionals_checkout_button') && !ready) {
      event.preventDefault(); event.stopImmediatePropagation(); sync();
    }
  }, true);
  document.addEventListener('submit', function (event) {
    if (event.target.closest('#rsi_form_wrapper') && !ready) { event.preventDefault(); event.stopImmediatePropagation(); sync(); }
  }, true);
  setPending();
  setInterval(function () {
    var form = document.getElementById('rsi_form_wrapper');
    var total = form && form.querySelector('.rsi-total-summary-total-value');
    if (!form || !total) return;
    if (!host.contains(form) || total.textContent !== lastTotal) { setPending(); sync(); }
  }, 350);
  sync();
})();
